import { render, staticRenderFns } from "./WasteUnitSettings.vue?vue&type=template&id=204ec12c&"
import script from "./WasteUnitSettings.vue?vue&type=script&lang=js&"
export * from "./WasteUnitSettings.vue?vue&type=script&lang=js&"
import style0 from "./WasteUnitSettings.vue?vue&type=style&index=0&id=204ec12c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports